import { render, staticRenderFns } from "./StartAddendum.vue?vue&type=template&id=0ef85cf0&"
import script from "./StartAddendum.vue?vue&type=script&lang=js&"
export * from "./StartAddendum.vue?vue&type=script&lang=js&"
import style0 from "./StartAddendum.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ef85cf0')) {
      api.createRecord('0ef85cf0', component.options)
    } else {
      api.reload('0ef85cf0', component.options)
    }
    module.hot.accept("./StartAddendum.vue?vue&type=template&id=0ef85cf0&", function () {
      api.rerender('0ef85cf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/addendum/StartAddendum.vue"
export default component.exports